import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4eceaa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "heading-title" }, "Documents", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "heading-subtitle" }, " Upload all relevant files, including insurance plan enrollment applications and any other forms mentioned in the notice letter, by clicking the \"Choose file\" button or dragging and dropping them into the upload area. ", -1))
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "on-drop"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"dragText\" data-v-f4eceaa6><span class=\"dragDrop\" data-v-f4eceaa6>Drag and Drop or </span><label for=\"file-input\" data-v-f4eceaa6>CHOOSE FILE</label> to upload </div><div class=\"drag-subtext\" data-v-f4eceaa6> Document types allowed for upload are &quot;jpeg, jpg, png, bmp, tiff, tif, pdf&quot; </div><div class=\"cloud-folder\" data-v-f4eceaa6></div>", 3)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppFooter = _resolveComponent("AppFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      (_ctx.validationMsg)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "alert alert-danger",
            innerHTML: _ctx.validationMsg
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["file-upload dragDropContainer", { 'on-drag': _ctx.isDragging }]),
        onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
        onDragenter: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
        onDrop: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)))
      }, [
        (_ctx.isDragging)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "DROP HERE"))
          : _createCommentVNode("", true),
        _hoisted_6,
        _createElementVNode("input", {
          type: "file",
          id: "file-input",
          style: {"display":"none"},
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args))),
          multiple: ""
        }, null, 32)
      ], 34),
      (_ctx.noticeLetterData)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn btn-primary-o download-notice w-fit-content",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.downloadNoticeLetter && _ctx.downloadNoticeLetter(...args)))
          }, " DOWNLOAD NOTICE LETTER "))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_AppFooter, {
      "save-btn-txt": _ctx.getDocumentSubmitBtn,
      "is-form-invalid": false,
      "is-submit-disabled": false,
      onSubmitHandler: _ctx.submitHandler
    }, null, 8, ["save-btn-txt", "onSubmitHandler"])
  ], 64))
}